var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "66", height: "64", viewBox: "0 0 66 64", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M64.125 62l-20.75-20m6.917-16.667c0 3.065-.627 6.099-1.843 8.93-1.217 2.83-3 5.403-5.248 7.57a24.287 24.287 0 0 1-7.854 5.058 25 25 0 0 1-9.264 1.776c-3.179 0-6.327-.604-9.264-1.776a24.288 24.288 0 0 1-7.854-5.058 23.296 23.296 0 0 1-5.247-7.57 22.603 22.603 0 0 1-1.843-8.93c0-6.188 2.55-12.123 7.09-16.499C13.505 4.458 19.663 2 26.083 2c6.42 0 12.578 2.458 17.118 6.834 4.54 4.376 7.09 10.31 7.09 16.5z", stroke: "#BCE1E5", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});